import { useState, useEffect } from 'react';

const FAVORITES_KEY = 'mobiuspack_favorites';

const useFavorites = () => {

    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        try {
            const saved = JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
            setFavorites(Array.isArray(saved) ? saved : []);
        } catch {
            localStorage.removeItem(FAVORITES_KEY);
        }
    }, []);

    const addFavorite = (label) => {
        const relativeUrl = window.location.pathname + window.location.search;
        const updated = [...favorites, { path: relativeUrl, label }].filter(
            (fav, i, arr) => arr.findIndex(f => f.path === fav.path) === i
        );
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(updated));
        setFavorites(updated);
    };

    const updateFavoriteLabel = (path, newLabel) => {
    const updated = favorites.map(fav =>
        fav.path === path ? { ...fav, label: newLabel } : fav
    );
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(updated));
    setFavorites(updated);
};

   
    const removeFavorite = (path) => {
        const updated = favorites.filter(f => f.path !== path);
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(updated));
        setFavorites(updated);
    };

    return { favorites, addFavorite, removeFavorite, updateFavoriteLabel };

}

export { useFavorites }